import { render, staticRenderFns } from "./allocation-suggestions-table.vue?vue&type=template&id=7285bd00"
import script from "./allocation-suggestions-table.vue?vue&type=script&lang=js"
export * from "./allocation-suggestions-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports